module.exports = __webpack_public_path__ + "img/promohead.9e8dea1b.jpg";